import { TableHeadersType } from "../tableHeadersType";

export const CLIENT_GROUP_HEADERS: TableHeadersType[] = [
  {
    label: "GROUP NAME",
    value: "client_group_name",
  },
  {
    label: "ASSIGNED CLIENT",
    value: "mapped_client",
  },
  {
    label: "CREATE/UPDATED BY",
    value: "created_at",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];

export const CLIENT_CATEGORY_HEADERS: TableHeadersType[] = [
  {
    label: "CATEGORY NAME",
    value: "name_of_category",
  },
  {
    label: "CREATE/UPDATED BY",
    value: "created_at",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];
export const USERS_DEPARTMENT_HEADERS: TableHeadersType[] = [
  {
    label: "DEPARTMENT NAME",
    value: "department_name",
  },
  {
    label: "CREATE/UPDATED BY",
    value: "created_at",
  },
  {
    label: "STATUS",
    value: "status",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];

export const PDF_TEMPLATE_HEADERS: TableHeadersType[] = [
  {
    label: "INVOICE TEMPLATE NAME",
    value: "pdf_template_name",
  },
  {
    label: "INVOICE TYPE",
    value: "invoice_type",
  },
  {
    label: "CREATE/UPDATED BY",
    value: "created_at",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];

export const SCOPE_OF_WORK_HEADERS: TableHeadersType[] = [
  {
    label: "SCOPE OF WORK NAME",
    value: "scope_of_work_name",
  },
  {
    label: "STATUS",
    value: "status",
  },
  {
    label: "CREATE/UPDATED BY",
    value: "created_at",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];
export const SKILLS_HEADERS: TableHeadersType[] = [
  {
    label: "SKILL NAME",
    value: "skill_name",
  },
  {
    label: "STATUS",
    value: "status",
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "created_at",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];

export const QUALIFICATION_HEADERS: TableHeadersType[] = [
  {
    label: "QUALIFICATION NAME",
    value: "qualification_name",
  },
  {
    label: "STATUS",
    value: "status",
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "created_at",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];

export const TDS_MODULE_HEADERS: TableHeadersType[] = [
  {
    label:"UNIQUE ID",
    value:"tds_id"
  },
  {
    label: "SECTION NAME",
    value: "section_name",
  },
  {
    label: "NATURE OF PAYMENT",
    value: "nature_of_payment",
  },
  {
    label: "RATE",
    value: "tds_rate",
  },
  {
    label: "EFFECTIVE DATE (OF LATEST RATE)",
    value: "tds_date",
  },

  {
    label: "THRESHOLD(Rs.)",
    value: "threshold",
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "created_at",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];
export const TCS_MODULE_HEADERS: TableHeadersType[] = [
  {
    label:"UNIQUE ID",
    value:"tcs_id"
  },
  {
    label: "SECTION NAME",
    value: "section_name",
  },
  {
    label: "NATURE OF PAYMENT",
    value: "nature_of_payment",
  },
  {
    label: "RATE",
    value: "tcs_rate",
  },
  {
    label: "EFFECTIVE DATE (OF LATEST RATE)",
    value: "tcs_date",
  },

  {
    label: "THRESHOLD(Rs.)",
    value: "threshold_amount",
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "created_at",
  },
  {
    label: "ACTION",
    value: "Edit",
  },
];